import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { CTAButton } from './components/CTAButton';
import { PurchasePopup } from './components/PurchasePopup';
import { Testimonial } from './components/Testimonial';
import { CheckIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://pagos.integradigital.shop/checkouts/cn/hWN7qmcjobybHOeCsyYJX5Kk/es-ar?_r=AQABXSIuLUor-EphQDjuOJO2KSzsu0_yfb4u6CICSsebDaE&cart_link_id=VhWwylVQ&preview_theme_id=183166402862';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1566039791207046');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1566039791207046&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      {/* Hero Section */}
      <section className="pt-16 pb-8 px-4 bg-white" data-id="element-3">
        <div className="max-w-4xl mx-auto text-center" data-id="element-4">
          <p className="text-gray-700 text-lg md:text-xl mb-6 leading-relaxed" data-id="element-5">
            📊 Para personas que quieren ordenar su dinero y crecer sin
            improvisar
          </p>

          <h1 className="text-4xl md:text-6xl font-black text-gray-900 mb-5 leading-tight" data-id="element-6">
            🔥 MEGAPACK – Control Total de tus Finanzas
          </h1>

          {/* Product Image - Clickable */}
          <a href={CHECKOUT_URL} className="block mb-6" data-id="element-7">
            <img src="https://cdn.magicpatterns.com/uploads/qrQZYDwq8S4bjudzCZ7wNT/Diseno_sin_titulo.png" alt="MEGAPACK Control Total de tus Finanzas" className="w-full max-w-2xl mx-auto rounded-lg shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-8" />
          </a>

          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 leading-relaxed" data-id="element-9">
            Sistema Integral de Control Financiero Personal
          </h2>

          <p className="text-xl md:text-2xl text-gray-700 mb-8 leading-relaxed" data-id="element-10">
            Tomá el control de tu dinero. Ordená tu vida. Empezá a crecer.
          </p>

          <CTAButton href={CHECKOUT_URL} className="mb-4" data-id="element-11">
            👉 SÍ, QUIERO ACCEDER AHORA
          </CTAButton>

          <p className="text-green-600 font-semibold text-lg" data-id="element-12">
            ✅ Garantía de satisfacción de 7 días
          </p>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-10 px-4 bg-gray-50" data-id="element-13">
        <div className="max-w-4xl mx-auto" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6 text-center" data-id="element-15">
            Si manejás plata todos los meses, dejame hacerte una pregunta
            honesta…
          </h2>

          <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 mb-6" data-id="element-16">
            <h3 className="text-2xl md:text-3xl font-bold text-red-600 mb-5 text-center" data-id="element-17">
              ¿Te pasa que trabajás… pero la plata nunca alcanza?
            </h3>

            <p className="text-lg text-gray-700 mb-5 leading-relaxed text-center" data-id="element-18">
              No porque seas desordenado. No porque seas irresponsable. No
              porque te falte disciplina.
            </p>

            <p className="text-xl font-bold text-gray-900 mb-5 text-center" data-id="element-19">
              Sino porque nadie te dio un sistema claro.
            </p>

            <div className="space-y-2 text-lg text-gray-700 text-center" data-id="element-20">
              <p data-id="element-21">Cobrás… pero no sabés exactamente en qué se va.</p>
              <p data-id="element-22">Intentás ahorrar… pero siempre aparece algo.</p>
              <p data-id="element-23">Querés organizarte… pero no sabés por dónde empezar.</p>
            </div>

            <p className="text-xl font-bold text-gray-900 mt-6 text-center" data-id="element-24">
              Y lo peor es esa sensación constante de:
              <br data-id="element-25" />
              <span className="text-red-600" data-id="element-26">
                "Estoy haciendo todo… pero igual no avanzo."
              </span>
            </p>
          </div>

          <div className="bg-yellow-50 border-4 border-yellow-400 rounded-lg p-6 mb-6" data-id="element-27">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-5 text-center" data-id="element-28">
              El problema que nadie dice en voz alta
            </h3>

            <p className="text-xl text-gray-800 mb-3 text-center" data-id="element-29">
              No es solo la plata.
            </p>

            <p className="text-2xl font-bold text-red-600 mb-5 text-center" data-id="element-30">
              👉 Es la sensación de no tener control.
            </p>

            <p className="text-lg text-gray-700 mb-3 text-center" data-id="element-31">
              Porque cuando no tenés un sistema:
            </p>

            <ul className="space-y-1.5 text-lg text-gray-700 text-center list-none" data-id="element-32">
              <li data-id="element-33">• Hacés cuentas mentales</li>
              <li data-id="element-34">• Improvisás cada mes</li>
              <li data-id="element-35">• Intentás ahorrar sin orden</li>
              <li data-id="element-36">• Ganás más… pero gastás más</li>
              <li data-id="element-37">• Vivís "a los ponchazos"</li>
              <li data-id="element-38">• Te cuesta proyectar</li>
              <li data-id="element-39">• Sentís culpa por gastar</li>
              <li data-id="element-40">• Nunca sabés realmente dónde estás parado</li>
            </ul>

            <p className="text-xl font-bold text-gray-900 mt-5 text-center" data-id="element-41">
              Y eso agota.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-10 px-4 bg-white" data-id="element-42">
        <div className="max-w-4xl mx-auto text-center" data-id="element-43">
          <div className="bg-green-600 text-white rounded-lg p-4 mb-8" data-id="element-44">
            <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-45">
              ✅ LA SOLUCIÓN
            </h2>
            <h3 className="text-xl md:text-2xl font-bold" data-id="element-46">
              MEGAPACK – Control Total de tus Finanzas
            </h3>
          </div>

          <p className="text-xl text-gray-700 mb-6 leading-relaxed" data-id="element-47">
            Un sistema estructurado en 4 etapas, diseñado para llevarte de:
          </p>

          <div className="grid md:grid-cols-3 gap-4 mb-8 text-left" data-id="element-48">
            <div className="bg-gray-50 rounded-lg p-5 shadow-md" data-id="element-49">
              <p className="text-lg font-bold text-gray-900 mb-2" data-id="element-50">
                👉 Confusión
              </p>
              <p className="text-gray-600" data-id="element-51">→ Claridad total</p>
            </div>
            <div className="bg-gray-50 rounded-lg p-5 shadow-md" data-id="element-52">
              <p className="text-lg font-bold text-gray-900 mb-2" data-id="element-53">
                👉 Estrés financiero
              </p>
              <p className="text-gray-600" data-id="element-54">→ Control consciente</p>
            </div>
            <div className="bg-gray-50 rounded-lg p-5 shadow-md" data-id="element-55">
              <p className="text-lg font-bold text-gray-900 mb-2" data-id="element-56">
                👉 Sobrevivir
              </p>
              <p className="text-gray-600" data-id="element-57">→ Empezar a crecer</p>
            </div>
          </div>

          <div className="bg-blue-50 rounded-lg p-6 mb-8" data-id="element-58">
            <div className="space-y-3 text-lg text-gray-800" data-id="element-59">
              <p data-id="element-60">📂 Abrís el sistema</p>
              <p data-id="element-61">📊 Usás la planilla</p>
              <p data-id="element-62">✍️ Aplicás el proceso paso a paso</p>
              <p className="text-xl font-bold text-blue-600" data-id="element-63">
                🎯 Recuperás control real
              </p>
            </div>
          </div>

          <p className="text-xl text-gray-700 mb-6" data-id="element-64">
            Sin improvisar. Sin depender de motivación. Sin empezar de cero cada
            mes.
          </p>

          <CTAButton href={CHECKOUT_URL} data-id="element-65">OBTENER MI MEGAPACK AHORA</CTAButton>
        </div>
      </section>

      {/* What Makes It Different */}
      <section className="py-10 px-4 bg-gray-50" data-id="element-66">
        <div className="max-w-4xl mx-auto" data-id="element-67">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-68">
            🧠 ¿Qué hace diferente a este MEGAPACK?
          </h2>

          <div className="bg-white rounded-lg shadow-lg p-6 mb-6" data-id="element-69">
            <h3 className="text-2xl font-bold text-gray-900 mb-5 text-center" data-id="element-70">
              La mayoría intenta:
            </h3>
            <ul className="space-y-2 text-lg text-gray-700 mb-6 text-center list-none" data-id="element-71">
              <li data-id="element-72">• Ahorrar sin orden</li>
              <li data-id="element-73">• Ganar más sin controlar gastos</li>
              <li data-id="element-74">• Improvisar cada mes</li>
              <li data-id="element-75">• Vivir "a ojo"</li>
              <li data-id="element-76">• Usar una planilla que no entiende</li>
              <li data-id="element-77">• Abandonar a los 7 días</li>
            </ul>
            <p className="text-xl font-bold text-red-600 mb-5 text-center" data-id="element-78">
              Eso no funciona.
            </p>
            <p className="text-xl font-bold text-green-600 text-center" data-id="element-79">
              Este sistema sí funciona porque sigue una lógica clara:
            </p>
            <p className="text-2xl font-black text-gray-900 mt-3 text-center" data-id="element-80">
              Primero control. Después crecimiento.
            </p>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-10 px-4 bg-white" data-id="element-81">
        <div className="max-w-4xl mx-auto" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-83">
            📘 ¿Qué incluye exactamente el MEGAPACK?
          </h2>

          {/* Stage 1 */}
          <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-6 mb-6 shadow-lg" data-id="element-84">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-85">
              🔹 ETAPA 1 – Mentalidad Financiera
            </h3>
            <p className="text-xl text-gray-800 mb-4" data-id="element-86">
              Primero ordenamos tu cabeza.
            </p>
            <p className="text-lg text-gray-700 mb-3" data-id="element-87">Vas a entender:</p>
            <ul className="space-y-1.5 text-lg text-gray-700" data-id="element-88">
              <li className="flex items-start" data-id="element-89">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-90" />
                <span data-id="element-91">Cómo influyen tus creencias sobre el dinero</span>
              </li>
              <li className="flex items-start" data-id="element-92">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-93" />
                <span data-id="element-94">Por qué repetís patrones financieros</span>
              </li>
              <li className="flex items-start" data-id="element-95">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-96" />
                <span data-id="element-97">Cómo salir de la mentalidad de escasez</span>
              </li>
              <li className="flex items-start" data-id="element-98">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-99" />
                <span data-id="element-100">Cómo tomar decisiones conscientes</span>
              </li>
            </ul>
            <p className="text-lg font-bold text-gray-900 mt-4" data-id="element-101">
              Sin mentalidad correcta, ningún sistema funciona.
            </p>
          </div>

          {/* Stage 2 */}
          <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-lg p-6 mb-6 shadow-lg border-4 border-orange-400" data-id="element-102">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-103">
              🔹 ETAPA 2 – Orden y Control Total (El corazón del sistema)
            </h3>
            <p className="text-xl text-gray-800 mb-4" data-id="element-104">
              Acá entra la herramienta que lo hace real:
            </p>

            <div className="bg-white rounded-lg p-5 mb-4 shadow-md" data-id="element-105">
              <h4 className="text-2xl font-black text-orange-600 mb-3" data-id="element-106">
                📊 Planilla Financiera de Control Total
              </h4>
              <p className="text-lg text-gray-700 mb-3" data-id="element-107">
                Esto no es una planilla común.
              </p>
              <p className="text-lg font-bold text-gray-900 mb-3" data-id="element-108">
                Es la herramienta práctica que te permite:
              </p>
              <ul className="space-y-1.5 text-lg text-gray-700" data-id="element-109">
                <li className="flex items-start" data-id="element-110">
                  <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-111" />
                  <span data-id="element-112">Ver todos tus ingresos en un solo lugar</span>
                </li>
                <li className="flex items-start" data-id="element-113">
                  <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-114" />
                  <span data-id="element-115">Identificar gastos invisibles</span>
                </li>
                <li className="flex items-start" data-id="element-116">
                  <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-117" />
                  <span data-id="element-118">Detectar fugas de dinero</span>
                </li>
                <li className="flex items-start" data-id="element-119">
                  <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-120" />
                  <span data-id="element-121">Tener claridad mensual real</span>
                </li>
                <li className="flex items-start" data-id="element-122">
                  <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-123" />
                  <span data-id="element-124">Dejar de vivir "a los ponchazos"</span>
                </li>
              </ul>
            </div>

            <p className="text-xl font-bold text-gray-900" data-id="element-125">
              La planilla es el centro del MEGAPACK. Porque cuando ves los
              números… recuperás el poder.
            </p>
          </div>

          {/* Stage 3 */}
          <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-lg p-6 mb-6 shadow-lg" data-id="element-126">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-127">
              🔹 ETAPA 3 – Hábitos y Ahorro Inteligente
            </h3>
            <p className="text-xl text-gray-800 mb-4" data-id="element-128">
              Ordenar una vez no alcanza.
            </p>
            <p className="text-xl text-gray-800 mb-4" data-id="element-129">Necesitás sostenerlo.</p>
            <p className="text-lg text-gray-700 mb-3" data-id="element-130">
              En esta fase vas a aprender:
            </p>
            <ul className="space-y-1.5 text-lg text-gray-700" data-id="element-131">
              <li className="flex items-start" data-id="element-132">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-133" />
                <span data-id="element-134">Cómo eliminar gastos hormiga</span>
              </li>
              <li className="flex items-start" data-id="element-135">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-136" />
                <span data-id="element-137">Cómo ahorrar sin sentir restricción</span>
              </li>
              <li className="flex items-start" data-id="element-138">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-139" />
                <span data-id="element-140">Cómo sostener el control sin agotarte</span>
              </li>
              <li className="flex items-start" data-id="element-141">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-142" />
                <span data-id="element-143">Cómo tomar mejores decisiones diarias</span>
              </li>
            </ul>
            <p className="text-xl font-bold text-gray-900 mt-4" data-id="element-144">
              Orden + hábito = estabilidad.
            </p>
          </div>

          {/* Stage 4 */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 mb-6 shadow-lg" data-id="element-145">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-146">
              🔹 ETAPA 4 – Ingresos Extra y Expansión
            </h3>
            <p className="text-xl text-gray-800 mb-4" data-id="element-147">
              Una vez que tenés control…
            </p>
            <p className="text-xl text-gray-800 mb-4" data-id="element-148">Podés crecer.</p>
            <p className="text-lg text-gray-700 mb-3" data-id="element-149">Vas a descubrir:</p>
            <ul className="space-y-1.5 text-lg text-gray-700" data-id="element-150">
              <li className="flex items-start" data-id="element-151">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-152" />
                <span data-id="element-153">Cómo generar ingresos extra realistas</span>
              </li>
              <li className="flex items-start" data-id="element-154">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-155" />
                <span data-id="element-156">Cómo diversificar sin fantasías</span>
              </li>
              <li className="flex items-start" data-id="element-157">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-158" />
                <span data-id="element-159">Cómo evaluar oportunidades sin caer en humo</span>
              </li>
              <li className="flex items-start" data-id="element-160">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-161" />
                <span data-id="element-162">Cómo dejar de depender de una sola fuente</span>
              </li>
            </ul>
            <p className="text-xl font-bold text-gray-900 mt-4" data-id="element-163">
              Primero control. Después expansión.
            </p>
          </div>

          <div className="text-center mt-8" data-id="element-164">
            <CTAButton href={CHECKOUT_URL} data-id="element-165">👉 ACCEDER CON DESCUENTO</CTAButton>
          </div>
        </div>
      </section>

      {/* Before vs After */}
      <section className="py-10 px-4 bg-black text-white" data-id="element-166">
        <div className="max-w-5xl mx-auto" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-black mb-8 text-center" data-id="element-168">
            🔄 Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-169">
            {/* Before */}
            <div className="bg-red-900 bg-opacity-30 rounded-lg p-6 border-2 border-red-500" data-id="element-170">
              <h3 className="text-2xl font-bold mb-5 text-red-400" data-id="element-171">
                ❌ Antes del MEGAPACK
              </h3>
              <ul className="space-y-2 text-lg" data-id="element-172">
                <li data-id="element-173">• Confusión constante</li>
                <li data-id="element-174">• Gastos invisibles</li>
                <li data-id="element-175">• Improvisación mensual</li>
                <li data-id="element-176">• Estrés financiero</li>
                <li data-id="element-177">• Culpa por gastar</li>
                <li data-id="element-178">• Vivir al día</li>
                <li data-id="element-179">• No poder proyectar</li>
              </ul>
            </div>

            {/* After */}
            <div className="bg-green-900 bg-opacity-30 rounded-lg p-6 border-2 border-green-500" data-id="element-180">
              <h3 className="text-2xl font-bold mb-5 text-green-400" data-id="element-181">
                ✅ Después del MEGAPACK
              </h3>
              <ul className="space-y-2 text-lg" data-id="element-182">
                <li data-id="element-183">• Claridad total</li>
                <li data-id="element-184">• Control real de tu dinero</li>
                <li data-id="element-185">• Ahorro sin sufrir</li>
                <li data-id="element-186">• Menos ansiedad financiera</li>
                <li data-id="element-187">• Decisiones seguras</li>
                <li data-id="element-188">• Estabilidad</li>
                <li data-id="element-189">• Expansión posible</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-10 px-4 bg-gradient-to-b from-orange-50 to-yellow-50" id="bonuses" data-id="element-190">
        <div className="max-w-5xl mx-auto" data-id="element-191">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3 text-center" data-id="element-192">
            🎁 Regalos especiales
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-orange-600 mb-8 text-center" data-id="element-193">
            BONOS INCLUIDOS HOY (sin costo adicional)
          </h3>

          <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-194">
            {/* Bonus 1 */}
            <a href={CHECKOUT_URL} className="block group" data-id="element-195">
              <div className="bg-white rounded-lg shadow-xl overflow-hidden transform group-hover:scale-105 transition-transform duration-300" data-id="element-196">
                <div className="relative" data-id="element-197">
                  <img src="https://cdn.magicpatterns.com/uploads/9Vty6YwawMfyp9soAHZuDm/ChatGPT_Image_16_feb_2026,_11_19_47.png" alt="Bono #1: Protocolo de 21 Días" className="w-full h-auto object-cover aspect-square" data-id="element-198" />
                  <div className="absolute top-4 right-4 bg-yellow-400 text-red-900 font-black text-lg px-4 py-2 rounded-full shadow-lg" data-id="element-199">
                    GRATIS HOY
                  </div>
                </div>
                <div className="p-5" data-id="element-200">
                  <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-201">
                    🎁 Bono #1 – Protocolo de 21 Días
                  </h4>
                  <p className="text-gray-700 mb-2" data-id="element-202">
                    Un plan práctico para cambiar tu relación con el dinero paso
                    a paso.
                  </p>
                  <p className="text-gray-500 line-through" data-id="element-203">
                    Valor: ARS $24.990
                  </p>
                  <p className="text-green-600 font-bold text-xl" data-id="element-204">
                    → HOY: GRATIS
                  </p>
                </div>
              </div>
            </a>

            {/* Bonus 2 */}
            <a href={CHECKOUT_URL} className="block group" data-id="element-205">
              <div className="bg-white rounded-lg shadow-xl overflow-hidden transform group-hover:scale-105 transition-transform duration-300" data-id="element-206">
                <div className="relative" data-id="element-207">
                  <img src="https://cdn.magicpatterns.com/uploads/vc4hQef9P434HV24LQcKGr/ChatGPT_Image_16_feb_2026,_11_22_01.png" alt="Bono #2: Ahorro Diario Consciente" className="w-full h-auto object-cover aspect-square" data-id="element-208" />
                  <div className="absolute top-4 right-4 bg-yellow-400 text-red-900 font-black text-lg px-4 py-2 rounded-full shadow-lg" data-id="element-209">
                    GRATIS HOY
                  </div>
                </div>
                <div className="p-5" data-id="element-210">
                  <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-211">
                    🎁 Bono #2 – Ahorro Diario Consciente
                  </h4>
                  <p className="text-gray-700 mb-2" data-id="element-212">
                    Microdecisiones simples que sostienen el cambio real.
                  </p>
                  <p className="text-gray-500 line-through" data-id="element-213">
                    Valor: ARS $15.990
                  </p>
                  <p className="text-green-600 font-bold text-xl" data-id="element-214">
                    → HOY: GRATIS
                  </p>
                </div>
              </div>
            </a>

            {/* Bonus 3 */}
            <a href={CHECKOUT_URL} className="block group" data-id="element-215">
              <div className="bg-white rounded-lg shadow-xl overflow-hidden transform group-hover:scale-105 transition-transform duration-300" data-id="element-216">
                <div className="relative" data-id="element-217">
                  <img src="https://cdn.magicpatterns.com/uploads/kreJ8ypWhB7zvSo3ZAxKLf/ChatGPT_Image_16_feb_2026,_11_25_25.png" alt="Bono #3: Guía de Ingresos Extra Realistas" className="w-full h-auto object-cover aspect-square" data-id="element-218" />
                  <div className="absolute top-4 right-4 bg-yellow-400 text-red-900 font-black text-lg px-4 py-2 rounded-full shadow-lg" data-id="element-219">
                    GRATIS HOY
                  </div>
                </div>
                <div className="p-5" data-id="element-220">
                  <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-221">
                    🎁 Bono #3 – Guía de Ingresos Extra Realistas
                  </h4>
                  <p className="text-gray-700 mb-2" data-id="element-222">
                    Ideas concretas, aplicables y sin humo.
                  </p>
                  <p className="text-gray-500 line-through" data-id="element-223">
                    Valor: ARS $45.990
                  </p>
                  <p className="text-green-600 font-bold text-xl" data-id="element-224">
                    → HOY: GRATIS
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-10 px-4 bg-white" data-id="element-225">
        <div className="max-w-4xl mx-auto" data-id="element-226">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6 text-center" data-id="element-227">
            ⏰ Oferta por tiempo limitado
          </h2>

          <div className="flex justify-center mb-6" data-id="element-228">
            <CountdownTimer data-id="element-229" />
          </div>

          <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-230">
            Accedé al MEGAPACK + los 3 Bonos de regalo
          </h3>

          <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-lg p-6 md:p-8 shadow-2xl mb-6" data-id="element-231">
            <h4 className="text-2xl font-bold text-gray-900 mb-5" data-id="element-232">
              📦 Lo que vas a recibir hoy:
            </h4>
            <ul className="space-y-2 text-lg text-gray-700 mb-6" data-id="element-233">
              <li className="flex items-start" data-id="element-234">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-235" />
                <span data-id="element-236">4 Tomos completos (aprox. 60 páginas cada uno)</span>
              </li>
              <li className="flex items-start" data-id="element-237">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-238" />
                <span data-id="element-239">
                  La Planilla Financiera de Control Total (herramienta central)
                </span>
              </li>
              <li className="flex items-start" data-id="element-240">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-241" />
                <span data-id="element-242">Bono #1: Protocolo de 21 días</span>
              </li>
              <li className="flex items-start" data-id="element-243">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-244" />
                <span data-id="element-245">Bono #2: Ahorro diario consciente</span>
              </li>
              <li className="flex items-start" data-id="element-246">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-247" />
                <span data-id="element-248">Bono #3: Guía de ingresos extra realistas</span>
              </li>
              <li className="flex items-start" data-id="element-249">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-250" />
                <span data-id="element-251">Acceso inmediato</span>
              </li>
              <li className="flex items-start" data-id="element-252">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-253" />
                <span data-id="element-254">Descarga digital</span>
              </li>
              <li className="flex items-start" data-id="element-255">
                <CheckIcon className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" data-id="element-256" />
                <span data-id="element-257">Acceso de por vida</span>
              </li>
            </ul>

            <div className="border-t-2 border-gray-300 pt-6 text-center" data-id="element-258">
              <p className="text-gray-600 text-xl mb-2 line-through" data-id="element-259">
                Precio regular: ARS $49.990
              </p>
              <div className="bg-red-600 text-white inline-block px-8 py-4 rounded-lg mb-4" data-id="element-260">
                <p className="text-4xl md:text-5xl font-black" data-id="element-261">
                  🔥 HOY SOLO: ARS $19.990
                </p>
              </div>
              <div className="space-y-1 text-lg text-gray-700" data-id="element-262">
                <p data-id="element-263">✔ Un solo pago</p>
                <p data-id="element-264">✔ Acceso inmediato</p>
                <p data-id="element-265">✔ Acceso de por vida</p>
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-266">
            <CTAButton href={CHECKOUT_URL} className="text-3xl" data-id="element-267">
              👉 OBTENER MI MEGAPACK HOY
            </CTAButton>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-10 px-4 bg-yellow-50" data-id="element-268">
        <div className="max-w-3xl mx-auto text-center" data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-270">
            🔒 Garantía sin riesgo
          </h2>
          <div className="bg-white rounded-lg shadow-lg p-6 border-4 border-yellow-400" data-id="element-271">
            <p className="text-xl text-gray-800 mb-3 leading-relaxed" data-id="element-272">
              Probalo durante 7 días.
            </p>
            <p className="text-xl text-gray-800 mb-3 leading-relaxed" data-id="element-273">
              Si no te da claridad, control y tranquilidad real, te devolvemos
              el 100% del dinero.
            </p>
            <p className="text-2xl font-bold text-green-600" data-id="element-274">Sin preguntas.</p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-10 px-4 bg-white" data-id="element-275">
        <div className="max-w-5xl mx-auto" data-id="element-276">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-277">
            🗣️ Lo que dicen otras personas
          </h2>

          <div className="space-y-4" data-id="element-278">
            <Testimonial name="Mariana" age={34} city="Córdoba" occupation="Madre de familia, empleada administrativa" quote="Por primera vez entendí en qué se me iba la plata. Me dio paz. Ahora puedo planificar sin estrés y sé exactamente dónde estoy parada cada mes." data-id="element-279" />

            <Testimonial name="Lucas" age={28} city="Buenos Aires" occupation="Freelancer, diseñador gráfico" quote="Con la planilla me di cuenta de fugas que ni veía. Tremendo. Como freelancer con ingresos variables, por fin tengo control real de mis finanzas." data-id="element-280" />

            <Testimonial name="Sofía" age={41} city="Ushuaia" occupation="Comerciante, dueña de local" quote="Dejé de vivir a ojo. Ahora sé exactamente dónde estoy parado. El sistema me ayudó a separar las finanzas del negocio de las personales y todo cambió." data-id="element-281" />

            <Testimonial name="Diego" age={36} city="Rosario" occupation="Empleado bancario" quote="Irónico que trabajara en un banco y no tuviera mis finanzas ordenadas. Este MEGAPACK me dio las herramientas que necesitaba para tomar control de verdad." data-id="element-282" />

            <Testimonial name="Carolina" age={29} city="Mendoza" occupation="Profesora, ingresos variables" quote="Con ingresos que varían cada mes, siempre vivía con ansiedad. La planilla me dio claridad y ahora puedo ahorrar incluso en los meses más ajustados." data-id="element-283" />
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-10 px-4 bg-gray-50" data-id="element-284">
        <div className="max-w-4xl mx-auto" data-id="element-285">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-286">
            Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-287">
            <div className="bg-white rounded-lg shadow-md p-5" data-id="element-288">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-289">
                ¿Es una planilla o un curso?
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-290">
                Es un sistema completo en 4 etapas + la planilla central que lo
                hace aplicable.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-5" data-id="element-291">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-292">
                ¿Necesito saber de finanzas?
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-293">
                No. Está pensado para gente común, explicado simple y paso a
                paso.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-5" data-id="element-294">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-295">
                ¿Es digital?
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-296">
                Sí. Acceso y descarga inmediata.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-5" data-id="element-297">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-298">
                ¿Funciona si tengo ingresos variables?
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-299">
                Sí. Justamente está diseñado para darte claridad incluso si
                cobrás distinto cada mes.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-5" data-id="element-300">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-301">
                ¿Sirve si estoy endeudado?
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-302">
                Sí. El sistema te ayuda a ordenar y recuperar control, incluso
                si estás en rojo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-10 px-4 bg-gradient-to-b from-orange-500 to-red-600 text-white" data-id="element-303">
        <div className="max-w-4xl mx-auto text-center" data-id="element-304">
          <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-305">
            Controlar tu dinero puede ser más simple
          </h2>

          <p className="text-xl md:text-2xl mb-4" data-id="element-306">No necesitás "ganar más".</p>

          <p className="text-xl md:text-2xl mb-6" data-id="element-307">
            Necesitás un sistema que te diga:
          </p>

          <div className="grid md:grid-cols-2 gap-3 mb-8 text-left max-w-2xl mx-auto" data-id="element-308">
            <div className="bg-white bg-opacity-20 rounded-lg p-3" data-id="element-309">
              <p className="text-xl" data-id="element-310">📌 Dónde estás</p>
            </div>
            <div className="bg-white bg-opacity-20 rounded-lg p-3" data-id="element-311">
              <p className="text-xl" data-id="element-312">📌 En qué se te va</p>
            </div>
            <div className="bg-white bg-opacity-20 rounded-lg p-3" data-id="element-313">
              <p className="text-xl" data-id="element-314">📌 Cómo ordenar</p>
            </div>
            <div className="bg-white bg-opacity-20 rounded-lg p-3" data-id="element-315">
              <p className="text-xl" data-id="element-316">📌 Cómo ahorrar</p>
            </div>
            <div className="bg-white bg-opacity-20 rounded-lg p-3 md:col-span-2" data-id="element-317">
              <p className="text-xl text-center" data-id="element-318">📌 Cómo crecer</p>
            </div>
          </div>

          <CTAButton href={CHECKOUT_URL} className="bg-white text-red-600 hover:bg-gray-100 text-3xl mb-4" data-id="element-319">
            👉 Accedé ahora al MEGAPACK – Control Total de tus Finanzas
          </CTAButton>

          <p className="text-xl italic" data-id="element-320">
            Porque no se trata de Excel. Se trata de recuperar el control de tu
            vida.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-6 px-4 bg-black text-white text-center" data-id="element-321">
        <p className="text-sm text-gray-400" data-id="element-322">
          © 2026 MEGAPACK Control Total de tus Finanzas. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}